// include npm plugin packages
window.$ = window.jQuery = require('jquery');
require('jquery-easing');
window.Pikaday = require('pikaday');
window.moment = require('moment');

require('moment/locale/de');
require('moment/locale/nl');
require('moment/locale/en-gb');

require('slick-carousel');
var Cookies = require('js-cookie');
require('jquery-mask-plugin');

window.L = require('leaflet');

// var lockr = require('lockr');
// require('waypoints/lib/jquery.waypoints');
// require('waypoints/lib/shortcuts/inview');

// global functionality goes here
window.WPLANG = document.documentElement.lang;
window.moment.locale(WPLANG.substring(0, 2));
window.wp_lang = WPLANG.replace('-', '_');

window.pikaday_labels = {};

window.pikaday_labels.nl_NL = {
    previousMonth: 'Vorige maand',
    nextMonth: 'Volgende maand',
    months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    monthsShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
};

window.pikaday_labels.en_US = {
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
};

window.pikaday_labels.de_DE = {
    previousMonth: 'Nächste Monat',
    nextMonth: 'Früher Monat',
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
};

window.pikaday_i18n = pikaday_labels[wp_lang] || pikaday_labels['nl_NL'];

// include local plugin packages
require('./lib/bootstrap-modules/affix');
require('./lib/bootstrap-modules/scrollspy');
require('./lib/bootstrap-modules/tooltips');
require('./lib/bootstrap-modules/tabs');
require('./lib/nivo-lightbox/nivo-lightbox.min.js');
//require('./lib/fontawesome/all.min');
//require('./lib/fontawesome/v4-shims.min');
require('./lib/dbk-maps/maps');

window.removeCookie = function (cookie) {
    Cookies.remove(cookie);
};

window.setCookie = function (cookie, value, expires) {
    Cookies.set(cookie, value, { expires: expires });
};

window.Cookies = Cookies;

window.iframeSetAspectRatio = function (elem) {
    var width = elem.outerWidth();
    var newHeight = (width / 16) * 9;
    elem.css('height', newHeight);
};

// function for calculating viewport sizes regardless of device or browser
window.viewport = function () {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

/*
** Require local packages
*/
var App = require('./lib/dbk-app/app');
/*
** Initialize the app.
** Example: If you have a template called 'templates-examples.php' add it here as: template_examples
** this code will only get executed on templates-examples.php
*/
var app = new App({
    global: require('./modules/global'),
    home: require('./modules/front-page'),
});
jQuery(document).ready(app.loadEvents);
